/* GAP photo tile sets: build a wall of 2-9 magnetic tiles (framed or dibond) with several photos on one screen.
   Config comes from the section: window.GAP_TILESET = { variants: { framed: { "<price>": variantId }, dibond: {...} }, rooms: {...} }.
   Shopify Basic cannot change a cart price in code, so the set goes to the cart as ONE line of a hidden "Photo tile set" product whose
   variant price equals the set total. Every tile (size, crop, photo links) is written to that line's properties.
   Photos go to Cloudinary (same unsigned preset as the other configurators). */
(function () {
  var C = window.GAP_TILESET, root = document.getElementById('gts');
  if (!C || !root) return;
  var CLOUD = 'drvkztoqo', PRESET = 'giftlyartprint_uploads', MAX_PX = 16000000, UPLOAD_TIMEOUT = 180000;

  var SIZES = [
    { id: '20x20', w: 20, h: 20, price: 18 },
    { id: '20x30', w: 20, h: 30, price: 20 },
    { id: '30x30', w: 30, h: 30, price: 30 },
    { id: '30x40', w: 30, h: 40, price: 34 },
    { id: '40x40', w: 40, h: 40, price: 54, maxN: 6 },
    { id: '40x50', w: 40, h: 50, price: 64, maxN: 6 },
    { id: '50x50', w: 50, h: 50, price: 72, maxN: 3 },
    { id: '50x70', w: 50, h: 70, price: 93, maxN: 3 },
    { id: '60x80', w: 60, h: 80, price: 106, maxN: 3 }
  ];
  var BORDERS = [0, 3, 5];
  var BCOLS = { white: { label: 'White', c: '#FFFFFF' }, off: { label: 'Off-white', c: '#F3F1EA' }, cream: { label: 'Cream', c: '#EFE6D0' } };
  var SETDISC = { 2: 0.05, 3: 0.10, 4: 0.12, 6: 0.15, 8: 0.18, 9: 0.20 };
  var LAYOUT = { 2: [2, 1], 3: [3, 1], 4: [2, 2], 6: [3, 2], 8: [4, 2], 9: [3, 3] };
  var MAT = {
    framed: { label: 'Framed', mult: 1, product: 'Magnetic framed tile set' },
    dibond: { label: 'Dibond', mult: 0.90, product: 'Magnetic dibond tile set', note: 'Frameless, 3 mm aluminium panel.' }
  };
  var FRAMES = { black: { label: 'Black', c: '#15171a' }, white: { label: 'White', c: '#f5f5f2' }, oak: { label: 'Oak', c: '#c49b5f' } };
  var WALLS = [{ label: 'White', c: '#EDEBEC' }, { label: 'Warm white', c: '#ECE6DA' }, { label: 'Cream', c: '#EFE3C8' }, { label: 'Greige', c: '#CFC6BA' }, { label: 'Sage', c: '#AEBBA8' }, { label: 'Sky', c: '#BFD0DC' }, { label: 'Blush', c: '#E2C9C4' }, { label: 'Charcoal', c: '#3C4249' }];
  var STEPS = [{ id: 'set', t: 'Set' }, { id: 'photos', t: 'Photos' }, { id: 'size', t: 'Size' }, { id: 'border', t: 'Border' }, { id: 'style', t: 'Style' }, { id: 'wall', t: 'Wall' }];
  var HANG_H = 145;
  var ROOMS = {
    living: { label: 'Living room', w: 384, h: 256, floorY: 203.5, furnTop: 143, wm: [236, 234, 237], img: C.rooms.living.img, mask: C.rooms.living.mask },
    bed: { label: 'Bedroom', w: 384, h: 256, floorY: 203.5, furnTop: 131, wm: [237, 232, 231], img: C.rooms.bed.img, mask: C.rooms.bed.mask }
  };

  var st = { count: 6, tiles: [], sel: 0, mat: 'framed', frame: 'black', border: 0, bcol: 'white', finish: 'matt', wall: '#EDEBEC', per: false, step: 'set', done: {}, view: 'edit', room: 'living', my: null, myW: 350, gap: 5, gx: null, gy: null, busy: false, full: false };
  var $ = function (id) { return document.getElementById('gts-' + id); };
  var sizeBy = function (id) { for (var i = 0; i < SIZES.length; i++) if (SIZES[i].id === id) return SIZES[i]; };
  var money = function (n) { return '£' + (Math.round(n * 100) / 100).toFixed(n % 1 ? 2 : 0); };
  var clamp = function (v, a, b) { return Math.max(a, Math.min(b, v)); };
  var mk = function (tag, cls, html, fn) { var e = document.createElement(tag); if (cls) e.className = cls; if (html != null) e.innerHTML = html; if (fn) e.onclick = fn; return e; };
  var pressed = function (e, v) { e.setAttribute('aria-pressed', String(!!v)); return e; };
  function say(msg, err) { var t = $('toast'); t.textContent = msg; t.classList.toggle('err', !!err); t.hidden = false; clearTimeout(t._h); t._h = setTimeout(function () { t.hidden = true; }, err ? 6000 : 3600); }

  /* ---------- tiles and prices ---------- */
  function sample(i) {
    var pal = [['#f6a56b', '#c8465b', '#3b2a5e'], ['#9dd6c8', '#3c7d8c', '#17324d'], ['#f2d58b', '#d98a3a', '#5a3320'], ['#bcd3f2', '#6c8fc9', '#27396b'], ['#e9b7d0', '#a8587f', '#48203d'], ['#c9e0a4', '#6a9a4f', '#233f2a'], ['#f4c4a1', '#b86a4a', '#40231a'], ['#a8c5d8', '#47788f', '#13303f'], ['#e6d3a3', '#9a8344', '#38301a']][i % 9];
    var s = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 300 400" preserveAspectRatio="none"><defs><linearGradient id="g" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="' + pal[0] + '"/><stop offset="1" stop-color="' + pal[1] + '"/></linearGradient></defs><rect width="300" height="400" fill="url(#g)"/><circle cx="' + (90 + i * 17 % 120) + '" cy="' + (120 + i * 23 % 60) + '" r="' + (34 + i % 3 * 8) + '" fill="#fff" opacity=".85"/><path d="M0 300 Q80 ' + (230 + i * 9 % 40) + ' 150 290 T300 270 V400 H0Z" fill="' + pal[2] + '" opacity=".75"/><path d="M0 345 Q100 300 200 340 T300 320 V400 H0Z" fill="' + pal[2] + '"/></svg>';
    return 'url("data:image/svg+xml;utf8,' + encodeURIComponent(s) + '")';
  }
  function newTile(i, size) { return { size: size || '30x30', land: false, img: sample(i), ar: 0.75, up: false, px: 50, py: 50, file: null, o: null }; }
  function resetTiles() {
    var old = st.tiles.slice(), t = [];
    for (var i = 0; i < st.count; i++) { t.push(old[i] ? old[i] : newTile(i, old[0] ? old[0].size : '30x30')); }
    t.forEach(function (x) { var m = sizeBy(x.size).maxN; if (m && st.count > m) x.size = st.count > 6 ? '30x40' : (m === 3 ? '40x50' : '30x40'); });
    st.tiles = t; if (st.sel >= t.length) st.sel = 0;
  }
  function tileCm(t) { var s = sizeBy(t.size); return t.land && s.w !== s.h ? { w: s.h, h: s.w } : { w: s.w, h: s.h }; }
  function tilePrice(t) { return Math.round(sizeBy(t.size).price * MAT[st.mat].mult); }
  function totals() { var sub = 0; st.tiles.forEach(function (t) { sub += tilePrice(t); }); var d = SETDISC[st.count] || 0, tot = Math.round(sub * (1 - d)); return { sub: sub, d: d, tot: tot, save: sub - tot, vid: (C.variants[st.mat] || {})[String(tot)] || null }; }
  function photoCount() { return st.tiles.filter(function (t) { return t.up; }).length; }

  /* ---------- edit view ---------- */
  function overflow(b, t) {
    var q = b.querySelector('.ph') || b, tw = q.clientWidth, th = q.clientHeight, iw = t.ar * 100, ih = 100;
    var s = Math.max(tw / iw, th / ih);
    return { x: iw * s - tw, y: ih * s - th };
  }
  var dragIcon = '<svg width="14" height="14" viewBox="0 0 14 14" fill="#fff" aria-hidden="true"><circle cx="4" cy="3" r="1.4"/><circle cx="10" cy="3" r="1.4"/><circle cx="4" cy="7" r="1.4"/><circle cx="10" cy="7" r="1.4"/><circle cx="4" cy="11" r="1.4"/><circle cx="10" cy="11" r="1.4"/></svg>';
  function styleTile(b, wpx, hpx, bw) {
    b.style.width = wpx.toFixed(2) + 'px'; b.style.height = hpx.toFixed(2) + 'px';
    b.style.backgroundColor = st.border ? BCOLS[st.bcol].c : '#ddd';
    if (st.mat === 'framed') { b.style.border = bw + 'px solid ' + FRAMES[st.frame].c; b.style.boxShadow = '0 6px 14px rgba(0,0,0,.28)'; }
    else { b.style.boxShadow = '0 0 0 1px rgba(0,0,0,.35),0 5px 12px rgba(0,0,0,.3)'; }
  }
  function addPh(b, t, sc) {
    var ph = document.createElement('span'); ph.className = 'ph';
    var ins = st.border * sc; ph.style.inset = ins.toFixed(2) + 'px';
    ph.style.backgroundImage = t.img; ph.style.backgroundSize = 'cover'; ph.style.backgroundPosition = t.px + '% ' + t.py + '%';
    b.insertBefore(ph, b.firstChild);
  }
  function tintColor() {
    var h = st.wall.replace('#', ''), c = [parseInt(h.substr(0, 2), 16), parseInt(h.substr(2, 2), 16), parseInt(h.substr(4, 2), 16)], wm = ROOMS[st.room].wm;
    return 'rgb(' + c.map(function (v, i) { return Math.min(255, Math.round(v * 255 / wm[i])); }).join(',') + ')';
  }
  function dims() {
    var maxW = 0, maxH = 0; st.tiles.forEach(function (t) { var c = tileCm(t); if (c.w > maxW) maxW = c.w; if (c.h > maxH) maxH = c.h; });
    var L = LAYOUT[st.count], cols = L[0], rows = L[1];
    return { cols: cols, rows: rows, maxW: maxW, maxH: maxH, gW: cols * maxW + (cols - 1) * st.gap, gH: rows * maxH + (rows - 1) * st.gap };
  }
  function roomCm() {
    if (st.room === 'mine') { var ar = st.my ? st.my.ar : 4 / 3; return { w: st.myW, h: st.myW / ar, ar: ar }; }
    var r = ROOMS[st.room]; return { w: r.w, h: r.h, ar: r.w / r.h };
  }
  function initPos() {
    var r = roomCm(), D = dims(); st.gx = r.w / 2;
    if (st.room === 'mine') { st.gy = r.h / 2; return; }
    var rm = ROOMS[st.room];
    st.gy = Math.max(Math.min(rm.floorY - HANG_H, rm.furnTop - 15 - D.gH / 2), D.gH / 2 + 8);
  }
  function renderReal() {
    var wall = $('wall'), room = $('room'), D = dims(), R = roomCm();
    var sw = wall.clientWidth, sh = wall.clientHeight, sc = sw / R.w;
    room.hidden = false; room.style.width = sw + 'px'; room.style.height = sh + 'px'; room.style.left = '0px'; room.style.top = '0px';
    room.style.backgroundImage = st.room === 'mine' ? (st.my ? st.my.img : 'none') : 'url("' + ROOMS[st.room].img + '")';
    room.style.backgroundColor = st.room === 'mine' && !st.my ? '#39414b' : 'transparent';
    room.innerHTML = '';
    if (st.room !== 'mine') {
      var tn = mk('div', 'tint'), mu = 'url("' + ROOMS[st.room].mask + '") 0 0/100% 100%';
      tn.style.background = tintColor(); tn.style.webkitMask = mu; tn.style.mask = mu; room.appendChild(tn);
    }
    var pk = st.count + '|' + st.gap + '|' + st.room + '|' + st.tiles.map(function (x) { return x.size + (x.land ? 'l' : ''); }).join(',');
    if (st.gx == null || st.posKey !== pk) { st.posKey = pk; initPos(); }
    st.gx = clamp(st.gx, Math.min(D.gW / 2, R.w / 2), Math.max(R.w - D.gW / 2, R.w / 2)); st.gy = clamp(st.gy, Math.min(D.gH / 2, R.h / 2), Math.max(R.h - D.gH / 2, R.h / 2));
    var g = mk('div', 'grp');
    g.style.gridTemplateColumns = 'repeat(' + D.cols + ',' + (D.maxW * sc) + 'px)'; g.style.gridAutoRows = (D.maxH * sc) + 'px'; g.style.gap = (st.gap * sc) + 'px';
    g.style.width = (D.gW * sc) + 'px'; g.style.height = (D.gH * sc) + 'px';
    g.style.left = ((st.gx - D.gW / 2) * sc) + 'px'; g.style.top = ((st.gy - D.gH / 2) * sc) + 'px';
    var bwPx = Math.max(2, 2 * sc);
    st.tiles.forEach(function (t) {
      var c = tileCm(t), cell = document.createElement('div'); cell.style.cssText = 'display:flex;align-items:center;justify-content:center';
      var b = mk('div', 'rt'); styleTile(b, c.w * sc, c.h * sc, bwPx);
      b.innerHTML = '<span style="position:absolute;inset:0;background:linear-gradient(115deg,rgba(255,255,255,.35),rgba(255,255,255,0) 38%);opacity:' + (st.finish === 'luster' ? .5 : 0) + '"></span>';
      addPh(b, t, sc); cell.appendChild(b); g.appendChild(cell);
    });
    room.appendChild(g);
    room.appendChild(mk('div', 'scalebar', '<i style="width:' + (100 * sc) + 'px"></i>1 m'));
    if (st.room === 'mine' && !st.my) room.appendChild(mk('div', 'roomMsg', 'Upload a photo of your wall in the Wall step'));
    attachGroup(g, sc, D, R); capReal(D, R);
  }
  function capReal(D, R) {
    var s = 'Set ' + Math.round(D.gW) + ' × ' + Math.round(D.gH) + ' cm';
    if (st.room !== 'mine') s += ' · centre ' + Math.round(ROOMS[st.room].floorY - st.gy) + ' cm from floor'; else s += ' · wall width ' + (st.myW / 100) + ' m';
    $('capL').textContent = s;
  }
  function attachGroup(g, sc, D, R) {
    var down = false, sx = 0, sy = 0, gx0 = 0, gy0 = 0;
    g.addEventListener('pointerdown', function (e) { down = true; sx = e.clientX; sy = e.clientY; gx0 = st.gx; gy0 = st.gy; g.classList.add('moving'); try { g.setPointerCapture(e.pointerId); } catch (_) {} });
    g.addEventListener('pointermove', function (e) {
      if (!down) return;
      st.gx = clamp(gx0 + (e.clientX - sx) / sc, 0, R.w); st.gy = clamp(gy0 + (e.clientY - sy) / sc, 0, R.h);
      g.style.left = ((st.gx - D.gW / 2) * sc) + 'px'; g.style.top = ((st.gy - D.gH / 2) * sc) + 'px'; capReal(D, R);
    });
    function up() { down = false; g.classList.remove('moving'); }
    g.addEventListener('pointerup', up); g.addEventListener('pointercancel', up);
  }
  function attachPan(b, t, i) {
    var down = false, moved = false, sx = 0, sy = 0, spx = 50, spy = 50;
    b.addEventListener('pointerdown', function (e) {
      if (e.target.closest('.drag')) return;
      down = true; moved = false; sx = e.clientX; sy = e.clientY; spx = t.px; spy = t.py;
      try { b.setPointerCapture(e.pointerId); } catch (_) {}
    });
    b.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - sx, dy = e.clientY - sy;
      if (Math.abs(dx) + Math.abs(dy) > 3) moved = true;
      if (!moved) return;
      var o = overflow(b, t);
      if (o.x > 0.5) t.px = clamp(spx - dx / o.x * 100, 0, 100);
      if (o.y > 0.5) t.py = clamp(spy - dy / o.y * 100, 0, 100);
      var q = b.querySelector('.ph'); if (q) q.style.backgroundPosition = t.px + '% ' + t.py + '%';
    });
    function up() { if (!down) return; down = false; st.sel = i; render(); }
    b.addEventListener('pointerup', up); b.addEventListener('pointercancel', function () { down = false; });
  }
  function attachMove(h, b, i) {
    var down = false, sx = 0, sy = 0, target = -1;
    h.addEventListener('pointerdown', function (e) { e.stopPropagation(); down = true; sx = e.clientX; sy = e.clientY; target = -1; b.classList.add('moving'); try { h.setPointerCapture(e.pointerId); } catch (_) {} });
    h.addEventListener('pointermove', function (e) {
      if (!down) return;
      b.style.transform = 'translate(' + (e.clientX - sx) + 'px,' + (e.clientY - sy) + 'px) scale(1.04)';
      var prev = b.style.pointerEvents; b.style.pointerEvents = 'none';
      var el = document.elementFromPoint(e.clientX, e.clientY); b.style.pointerEvents = prev;
      var tb = el && el.closest ? el.closest('.tile') : null;
      root.querySelectorAll('.tile.drop').forEach(function (x) { x.classList.remove('drop'); });
      target = -1;
      if (tb && tb !== b) { tb.classList.add('drop'); target = parseInt(tb.getAttribute('data-i'), 10); }
    });
    function end(commit) {
      if (!down) return; down = false;
      b.classList.remove('moving'); b.style.transform = '';
      root.querySelectorAll('.tile.drop').forEach(function (x) { x.classList.remove('drop'); });
      if (commit && target >= 0 && target !== i) { var a = st.tiles[i]; st.tiles[i] = st.tiles[target]; st.tiles[target] = a; st.sel = target; }
      render();
    }
    h.addEventListener('pointerup', function () { end(true); }); h.addEventListener('pointercancel', function () { end(false); });
  }
  function renderWall() {
    var wall = $('wall'), sets = $('sets'), L = LAYOUT[st.count], cols = L[0], rows = L[1];
    $('vEdit').setAttribute('aria-pressed', String(st.view === 'edit')); $('vReal').setAttribute('aria-pressed', String(st.view === 'real'));
    $('capR').textContent = st.view === 'edit' ? 'Drag a photo to reframe it · drag the handle to swap tiles' : 'Real scale · drag the set';
    var stg = wall.parentNode;
    $('fsBtn').hidden = st.view !== 'real';
    if (st.view === 'real') {
      var RR = roomCm(), aH = stg.clientHeight - (st.full ? 0 : 70), aW = stg.clientWidth;
      var hh = Math.min(aW / RR.ar, aH); if (!(hh > 0)) hh = 100;
      wall.style.flex = '0 0 auto'; wall.style.alignSelf = 'center'; wall.style.height = hh.toFixed(1) + 'px'; wall.style.width = (hh * RR.ar).toFixed(1) + 'px';
      wall.style.background = 'transparent'; sets.hidden = true; renderReal(); return;
    }
    wall.style.flex = ''; wall.style.alignSelf = ''; wall.style.height = ''; wall.style.width = '';
    $('room').hidden = true; sets.hidden = false; wall.style.background = st.wall;
    var maxW = 0, maxH = 0; st.tiles.forEach(function (t) { var c = tileCm(t); if (c.w > maxW) maxW = c.w; if (c.h > maxH) maxH = c.h; });
    var W = wall.clientWidth * 0.9, H = wall.clientHeight * 0.82;
    var sc = Math.min(W / (cols * maxW + (cols - 1) * st.gap), H / (rows * maxH + (rows - 1) * st.gap));
    var gap = Math.max(3, st.gap * sc); if (!(sc > 0)) sc = 1;
    sets.style.gridTemplateColumns = 'repeat(' + cols + ',' + Math.floor(maxW * sc) + 'px)'; sets.style.gridAutoRows = Math.floor(maxH * sc) + 'px'; sets.style.gap = gap + 'px';
    sets.innerHTML = '';
    var bw = Math.max(3, Math.round(Math.min(maxW * sc, maxH * sc) * 0.045));
    st.tiles.forEach(function (t, i) {
      var c = tileCm(t), cell = document.createElement('div'); cell.style.cssText = 'display:flex;align-items:center;justify-content:center';
      var b = document.createElement('div'); b.setAttribute('role', 'button'); b.tabIndex = 0; b.setAttribute('data-i', String(i));
      b.className = 'tile' + (i === st.sel ? ' sel' : '') + (st.finish === 'luster' ? ' luster' : '');
      b.setAttribute('aria-label', 'Tile ' + (i + 1) + ', ' + c.w + 'x' + c.h + ' cm. Drag to reframe the photo.');
      styleTile(b, c.w * sc, c.h * sc, bw);
      b.innerHTML = '<span class="shine"></span><span class="n">' + (i + 1) + '</span><span class="drag" role="button" aria-label="Move tile ' + (i + 1) + '">' + dragIcon + '</span>';
      addPh(b, t, sc);
      b.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); st.sel = i; render(); } });
      attachPan(b, t, i); attachMove(b.querySelector('.drag'), b, i);
      cell.appendChild(b); sets.appendChild(cell);
    });
    $('capL').textContent = st.count + ' tiles, ' + MAT[st.mat].label + (st.mat === 'framed' ? ' (' + FRAMES[st.frame].label + ')' : '') + ', ' + st.finish;
  }

  /* ---------- steps ---------- */
  function mark(id) { st.done[id] = true; }
  function setStep(id) { st.step = id; st.view = (id === 'wall') ? 'real' : 'edit'; if (id === 'wall' && st.gx == null) initPos(); }
  function nextStep() { var i = 0; for (; i < STEPS.length; i++) if (STEPS[i].id === st.step) break; return STEPS[Math.min(i + 1, STEPS.length - 1)].id; }
  function firstOpen() { for (var i = 0; i < STEPS.length; i++) if (!st.done[STEPS[i].id]) return STEPS[i].id; return null; }
  function summary(id) {
    if (id === 'set') return st.count + ' tiles';
    if (id === 'photos') return photoCount() + '/' + st.count;
    if (id === 'size') { var s = {}; st.tiles.forEach(function (t) { s[t.size] = 1; }); var k = Object.keys(s); return k.length > 1 ? 'mixed' : k[0]; }
    if (id === 'border') return st.border ? st.border + ' cm' : 'None';
    if (id === 'style') return st.mat === 'framed' ? FRAMES[st.frame].label : MAT[st.mat].label;
    return st.room === 'mine' ? 'My wall' : ROOMS[st.room].label;
  }
  function renderTabs() {
    var tabs = $('tabs'); tabs.innerHTML = ''; var fo = firstOpen();
    STEPS.forEach(function (s) {
      var d = !!st.done[s.id], sel = s.id === st.step;
      var b = mk('button', 'tab' + (d ? ' done' : '') + (!d && !sel && fo === s.id ? ' next' : ''), (d ? '✓ ' : '') + s.t + '<i>' + (d ? summary(s.id) : 'select') + '</i>', function () { setStep(s.id); render(); });
      b.type = 'button'; b.setAttribute('role', 'tab'); b.setAttribute('aria-selected', String(sel)); tabs.appendChild(b);
    });
  }
  function cont(label) { var b = mk('button', 'btn full', label || 'Continue', function () { mark(st.step); setStep(nextStep()); render(); }); b.type = 'button'; return b; }
  function upInfoText() {
    var n = photoCount(); if (!n) return 'Sample images for now. Pick several photos at once; they fill the tiles in order.';
    var done = 0, err = 0; st.tiles.forEach(function (t) { if (t.up && t.o) { if (t.o.s === 'done') done++; else if (t.o.s === 'err') err++; } });
    return n + ' of ' + st.count + ' tiles have your photo' + (done < n ? ' · saving ' + done + '/' + n + (err ? ' (' + err + ' will retry at checkout)' : '') : ' · all saved') + '. Drag a photo inside its tile to reframe it.';
  }
  function refreshUpInfo() { var e = $('upinfo'); if (e) e.textContent = upInfoText(); }

  function renderPane() {
    var p = $('pane'); p.innerHTML = ''; var r;
    if (st.step === 'set') {
      r = mk('div', 'row'); [2, 3, 4, 6, 8, 9].forEach(function (n) { var c = mk('button', 'chip', n + '<small>-' + Math.round(SETDISC[n] * 100) + '%</small>', function () { st.count = n; resetTiles(); mark('set'); render(); }); c.type = 'button'; r.appendChild(pressed(c, n === st.count)); });
      p.appendChild(r);
      var gr = mk('div', 'row'); [3, 5, 8].forEach(function (g) { var c = mk('button', 'chip sm', 'Gap ' + g + ' cm', function () { st.gap = g; render(); }); c.type = 'button'; gr.appendChild(pressed(c, g === st.gap)); });
      p.appendChild(gr);
      p.appendChild(mk('p', 'hint', 'Bigger sets get a bigger discount. Gap is the space between tiles on your wall.')); p.appendChild(cont());
    } else if (st.step === 'photos') {
      r = mk('div', 'row');
      var a = mk('button', 'btn', 'Add photos', function () { $('files').click(); }); a.type = 'button'; a.style.flex = '1'; r.appendChild(a);
      var o = mk('button', 'btn alt', 'Replace tile #' + (st.sel + 1), function () { $('one').click(); }); o.type = 'button'; o.style.flex = '1'; r.appendChild(o);
      p.appendChild(r);
      var h = mk('p', 'hint', upInfoText()); h.id = 'gts-upinfo'; p.appendChild(h);
      p.appendChild(cont(photoCount() ? 'Continue' : 'Continue with samples'));
    } else if (st.step === 'size') {
      var sel = st.tiles[st.sel];
      r = mk('div', 'row'); var cur = st.per ? sel.size : st.tiles[0].size; var shown = 0;
      SIZES.forEach(function (s) {
        if (s.maxN && st.count > s.maxN) return;
        if (shown && shown % 4 === 0) { p.appendChild(r); r = mk('div', 'row'); }
        shown++;
        var c = mk('button', 'chip', s.id + '<small>' + money(Math.round(s.price * MAT[st.mat].mult)) + '</small>', function () { if (st.per) st.tiles[st.sel].size = s.id; else st.tiles.forEach(function (t) { t.size = s.id; }); mark('size'); render(); });
        c.type = 'button'; r.appendChild(pressed(c, s.id === cur));
      });
      p.appendChild(r);
      if (st.count > 6) p.appendChild(mk('p', 'hint', 'Sets of 8 and 9 come in sizes up to 30x40 cm.')); else if (st.count > 3) p.appendChild(mk('p', 'hint', 'Sizes up to 40x50 cm for sets of 4 and 6. 50x50 to 60x80 cm for sets of 2 and 3.'));
      r = mk('div', 'row');
      var m1 = mk('button', 'chip sm', 'All tiles', function () { st.per = false; render(); }); m1.type = 'button'; pressed(m1, !st.per);
      var m2 = mk('button', 'chip sm', 'Only #' + (st.sel + 1), function () { st.per = true; render(); }); m2.type = 'button'; pressed(m2, st.per);
      var m3 = mk('button', 'chip sm', 'Rotate', function () { if (st.per) sel.land = !sel.land; else { var f = !st.tiles[0].land; st.tiles.forEach(function (t) { t.land = f; }); } render(); }); m3.type = 'button';
      r.appendChild(m1); r.appendChild(m2); r.appendChild(m3); p.appendChild(r); p.appendChild(cont());
    } else if (st.step === 'border') {
      r = mk('div', 'row');
      BORDERS.forEach(function (v) { var c = mk('button', 'chip', v ? v + ' cm' : 'Borderless', function () { st.border = v; mark('border'); render(); }); c.type = 'button'; r.appendChild(pressed(c, v === st.border)); });
      p.appendChild(r);
      r = mk('div', 'row'); r.style.alignItems = 'center';
      if (st.border) { Object.keys(BCOLS).forEach(function (k) { var c = mk('button', 'chip sm', '<span style="display:inline-block;width:12px;height:12px;border-radius:2px;vertical-align:-2px;margin-right:5px;border:1px solid rgba(0,0,0,.35);background:' + BCOLS[k].c + '"></span>' + BCOLS[k].label, function () { st.bcol = k; mark('border'); render(); }); c.type = 'button'; r.appendChild(pressed(c, k === st.bcol)); }); p.appendChild(r); }
      p.appendChild(mk('p', 'hint', st.border ? 'The border is printed around your photo. The tile keeps its outer size, so the photo shows a little smaller.' : 'The photo runs edge to edge.'));
      p.appendChild(cont());
    } else if (st.step === 'style') {
      r = mk('div', 'row');
      [['framed', 'Framed'], ['dibond', 'Dibond']].forEach(function (x) { var c = mk('button', 'chip sm', x[1], function () { st.mat = x[0]; mark('style'); render(); }); c.type = 'button'; r.appendChild(pressed(c, x[0] === st.mat)); });
      p.appendChild(r);
      r = mk('div', 'row');
      if (st.mat === 'framed') { Object.keys(FRAMES).forEach(function (k) { var c = mk('button', 'chip sm', FRAMES[k].label, function () { st.frame = k; mark('style'); render(); }); c.type = 'button'; r.appendChild(pressed(c, k === st.frame)); }); }
      else { r.appendChild(mk('p', 'hint', MAT[st.mat].note)); }
      p.appendChild(r);
      var f1 = mk('button', 'chip sm', 'Matt', function () { st.finish = 'matt'; mark('style'); render(); }); f1.type = 'button'; pressed(f1, st.finish === 'matt');
      var f2 = mk('button', 'chip sm', 'Luster <small>satin</small>', function () { st.finish = 'luster'; mark('style'); render(); }); f2.type = 'button'; pressed(f2, st.finish === 'luster');
      var r2 = mk('div', 'row'); r2.appendChild(f1); r2.appendChild(f2); p.appendChild(r2);
      p.appendChild(mk('p', 'hint', st.finish === 'luster' ? 'Luster is a satin, semi-gloss paper: richer colour than matt with little glare.' : 'Matt paper: soft, no reflections, a fine-art look.'));
      p.appendChild(cont());
    } else {
      r = mk('div', 'row');
      [['living', 'Living room'], ['bed', 'Bedroom'], ['mine', 'My own wall']].forEach(function (x) {
        var c = mk('button', 'chip sm', x[1], function () { st.room = x[0]; st.gx = null; if (x[0] === 'mine' && !st.my) $('wallPhoto').click(); if (x[0] !== 'mine') mark('wall'); render(); });
        c.type = 'button'; r.appendChild(pressed(c, st.room === x[0]));
      });
      p.appendChild(r);
      if (st.room !== 'mine') {
        r = mk('div', 'row'); r.style.alignItems = 'center'; r.style.flexWrap = 'wrap';
        WALLS.forEach(function (x) { var b = mk('button', 'sw', '', function () { st.wall = x.c; mark('wall'); render(); }); b.type = 'button'; b.title = x.label; b.setAttribute('aria-label', x.label); b.style.background = x.c; r.appendChild(pressed(b, x.c.toLowerCase() === st.wall.toLowerCase())); });
        var cl = mk('label', 'sw', '<input type="color" value="' + st.wall + '" aria-label="Custom wall colour" style="opacity:0;position:absolute;inset:0;width:100%;height:100%;cursor:pointer">');
        cl.style.cssText += ';position:relative;overflow:hidden;background:conic-gradient(#f26b1d,#f2c21d,#4fb85a,#2d9ad6,#7a4fd1,#d6457a,#f26b1d)'; cl.title = 'Custom colour';
        cl.querySelector('input').addEventListener('change', function (e) { st.wall = e.target.value; mark('wall'); render(); });
        r.appendChild(cl); p.appendChild(r);
        p.appendChild(mk('p', 'hint', 'True scale on a wall about 3.8 m wide. Pick any wall colour and drag the set to move it. Tap ⛶ for full screen and turn your phone sideways.'));
      } else {
        r = mk('div', 'row');
        var up = mk('button', 'chip sm', st.my ? 'Change wall photo' : 'Upload wall photo', function () { $('wallPhoto').click(); }); up.type = 'button'; r.appendChild(up);
        [300, 350, 400].forEach(function (cm) { var c = mk('button', 'chip sm', 'Wall ' + (cm / 100) + ' m', function () { st.myW = cm; st.gx = null; mark('wall'); render(); }); c.type = 'button'; r.appendChild(pressed(c, cm === st.myW)); });
        p.appendChild(r); p.appendChild(mk('p', 'hint', 'Tip: stand straight on, include about 3 to 4 m of wall, then tell us roughly how wide it is. Scale is only as good as that estimate. Your wall photo stays on your device.'));
      }
      p.appendChild(cont('Done'));
    }
  }

  function addState() {
    var left = firstOpen(), T = totals(), np = st.count - photoCount();
    if (st.busy) return { ok: false, label: st.busyLabel || 'Working…' };
    if (np > 0) return { ok: false, label: np + (np === 1 ? ' photo to add' : ' photos to add') };
    if (left) { var n = STEPS.filter(function (s) { return !st.done[s.id]; }).length; return { ok: false, label: n + (n === 1 ? ' step left' : ' steps left') }; }
    if (!T.vid) return { ok: false, label: 'Price unavailable' };
    return { ok: true, label: 'Add to cart' };
  }
  function renderBar() {
    var T = totals(), A = addState();
    $('barTot').textContent = money(T.tot);
    var o = $('barOld'); o.hidden = !T.d; o.textContent = T.d ? money(T.sub) : '';
    $('barMeta').textContent = st.count + ' tiles' + (T.d ? ' · set price -' + Math.round(T.d * 100) + '%' : '');
    var a = $('add'); a.disabled = !A.ok; a.className = 'btn go' + (A.ok ? ' pulse' : ''); a.textContent = A.label;
  }
  function render() { renderWall(); renderTabs(); renderPane(); renderBar(); }

  /* ---------- photos: read, thumbnail, background upload ---------- */
  var IOS = /iP(hone|ad|od)/.test(navigator.userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
  var OK_TYPE = /^image\/(jpeg|pjpeg|png|webp)$/i, OK_EXT = /\.(jpe?g|png|webp)$/i, HEIC_TYPE = /^image\/hei[cf](-sequence)?$/i, HEIC_EXT = /\.hei[cf]$/i;
  var HEIC_LIB = 'https://cdn.jsdelivr.net/npm/heic2any@0.0.4/dist/heic2any.min.js', libP = null;
  var ACCEPT = IOS ? 'image/jpeg,image/png,image/webp,.jpg,.jpeg,.png,.webp' : 'image/jpeg,image/png,image/webp,image/heic,image/heif,.jpg,.jpeg,.png,.webp,.heic,.heif';
  function loadLib() {
    if (libP) return libP;
    libP = new Promise(function (ok, fail) {
      if (window.heic2any) return ok(window.heic2any);
      var s = document.createElement('script'); s.src = HEIC_LIB; s.async = true;
      s.onload = function () { window.heic2any ? ok(window.heic2any) : fail(new Error('no lib')); };
      s.onerror = function () { libP = null; fail(new Error('load failed')); };
      document.head.appendChild(s);
    });
    return libP;
  }
  function toUsable(f) {
    if (OK_TYPE.test(f.type) || (!f.type && OK_EXT.test(f.name))) return Promise.resolve(f);
    if (HEIC_TYPE.test(f.type) || HEIC_EXT.test(f.name)) {
      return loadLib().then(function (h) { return h({ blob: f, toType: 'image/jpeg', quality: 0.95 }); }).then(function (out) {
        var blob = Array.isArray(out) ? out[0] : out;
        return new File([blob], f.name.replace(HEIC_EXT, '') + '.jpg', { type: 'image/jpeg', lastModified: Date.now() });
      });
    }
    return Promise.reject(new Error('type'));
  }
  function loadImg(url) { return new Promise(function (ok, fail) { var im = new Image(); im.onload = function () { ok(im); }; im.onerror = function () { fail(new Error('decode')); }; im.src = url; }); }
  function readOne(f) {
    return toUsable(f).then(function (file) {
      var u = URL.createObjectURL(file);
      return loadImg(u).then(function (im) {
        var w = im.naturalWidth || 3, h = im.naturalHeight || 4, k = Math.min(1, 900 / Math.max(w, h));
        var c = document.createElement('canvas'); c.width = Math.max(1, Math.round(w * k)); c.height = Math.max(1, Math.round(h * k));
        c.getContext('2d').drawImage(im, 0, 0, c.width, c.height);
        URL.revokeObjectURL(u); im.src = '';
        return new Promise(function (ok) { c.toBlob(function (b) { ok({ file: file, img: 'url("' + URL.createObjectURL(b) + '")', ar: w / h }); }, 'image/jpeg', 0.85); });
      });
    });
  }
  function readFiles(list, cb) {
    var arr = Array.prototype.slice.call(list), out = [], bad = 0, chain = Promise.resolve();
    if (!arr.length) return;
    arr.forEach(function (f) { chain = chain.then(function () { return readOne(f).then(function (p) { out.push(p); }, function () { bad++; }); }); });
    chain.then(function () {
      if (bad) say(bad + (bad === 1 ? ' file' : ' files') + ' could not be used. Please choose JPG, PNG, WebP or HEIC photos, or WhatsApp us on 07445 250359.', true);
      if (out.length) cb(out);
    });
  }
  function xhrUpload(blobOrFile, onProgress) {
    return new Promise(function (ok, fail) {
      var fd = new FormData(); fd.append('file', blobOrFile); fd.append('upload_preset', PRESET); fd.append('folder', 'giftlyartprint/orders');
      var x = new XMLHttpRequest(); x.open('POST', 'https://api.cloudinary.com/v1_1/' + CLOUD + '/image/upload', true);
      if (onProgress) x.upload.onprogress = function (e) { if (e.lengthComputable) onProgress(Math.round(e.loaded / e.total * 100)); };
      x.onload = function () { if (x.status === 200) { try { var r = JSON.parse(x.responseText); r.secure_url ? ok(r.secure_url) : fail('No file address returned'); } catch (e) { fail('Unreadable response'); } } else fail('Upload failed (' + x.status + ')'); };
      x.onerror = function () { fail('Network error'); }; x.timeout = UPLOAD_TIMEOUT; x.ontimeout = function () { fail('the connection timed out'); };
      x.send(fd);
    });
  }
  var q = [], running = 0, LIMIT = 2;
  function enqueue(job) { return new Promise(function (ok, fail) { q.push({ job: job, ok: ok, fail: fail }); pump(); }); }
  function pump() {
    while (running < LIMIT && q.length) {
      (function (it) { running++; it.job().then(it.ok, it.fail).then(function () { running--; pump(); }); })(q.shift());
    }
  }
  function startOriginal(t) {
    t.o = { s: 'busy', url: null, p: null };
    var o = t.o;
    o.p = enqueue(function () { return xhrUpload(t.file); }).then(function (u) { o.s = 'done'; o.url = u; refreshUpInfo(); return u; }, function (e) { o.s = 'err'; refreshUpInfo(); throw e; });
    o.p.catch(function () {});
  }
  function putPhoto(t, p) {
    t.img = p.img; t.ar = p.ar; t.up = true; t.px = 50; t.py = 50; t.file = p.file;
    var s = sizeBy(t.size); if (s.w !== s.h) t.land = p.ar > 1.15;
    startOriginal(t);
  }
  var ALLOWED = [3, 4, 6, 8, 9];
  $('files').onchange = function (e) {
    var el = e.target, files = Array.prototype.slice.call(el.files); el.value = '';
    readFiles(files, function (photos) {
      var over = 0;
      photos.forEach(function (p) {
        var idx = -1; for (var i = 0; i < st.tiles.length; i++) if (!st.tiles[i].up) { idx = i; break; }
        if (idx < 0) {
          for (var k = 0; k < ALLOWED.length; k++) if (ALLOWED[k] > st.count) { st.count = ALLOWED[k]; resetTiles(); break; }
          for (var j = 0; j < st.tiles.length; j++) if (!st.tiles[j].up) { idx = j; break; }
        }
        if (idx >= 0) putPhoto(st.tiles[idx], p); else over++;
      });
      if (over) say('A set holds up to 9 photos. ' + over + (over === 1 ? ' photo was' : ' photos were') + ' not added.', true);
      mark('photos'); mark('set'); render();
    });
  };
  $('one').onchange = function (e) { var el = e.target, f = el.files; el.value = ''; readFiles(f, function (photos) { putPhoto(st.tiles[st.sel], photos[0]); mark('photos'); render(); }); };
  $('wallPhoto').onchange = function (e) {
    var el = e.target, f = el.files && el.files[0]; el.value = ''; if (!f) return;
    toUsable(f).then(function (file) { var u = URL.createObjectURL(file); return loadImg(u).then(function (im) { st.my = { img: 'url("' + u + '")', ar: (im.naturalWidth || 4) / (im.naturalHeight || 3) }; st.room = 'mine'; st.gx = null; mark('wall'); render(); }); })
      .catch(function () { say('We could not read that photo. Please try a JPG or PNG.', true); });
  };
  $('files').setAttribute('accept', ACCEPT); $('one').setAttribute('accept', ACCEPT); $('wallPhoto').setAttribute('accept', ACCEPT);

  /* ---------- print-ready files and cart ---------- */
  function printCanvas(t, im) {
    var c = tileCm(t), pxPerCm = 118, W = Math.round(c.w * pxPerCm), H = Math.round(c.h * pxPerCm), maxSide = 6000;
    if (Math.max(W, H) > maxSide) { var k = maxSide / Math.max(W, H); W = Math.round(W * k); H = Math.round(H * k); }
    if (W * H > MAX_PX) { var k2 = Math.sqrt(MAX_PX / (W * H)); W = Math.floor(W * k2); H = Math.floor(H * k2); }
    var cv = document.createElement('canvas'); cv.width = W; cv.height = H;
    var g = cv.getContext('2d'); if (!g) throw new Error('canvas');
    g.imageSmoothingEnabled = true; g.imageSmoothingQuality = 'high';
    var bPx = Math.round(st.border * (W / c.w));
    if (bPx > 0) { g.fillStyle = BCOLS[st.bcol].c; g.fillRect(0, 0, W, H); }
    var iw = W - 2 * bPx, ih = H - 2 * bPx, iW = im.naturalWidth, iH = im.naturalHeight;
    var scale = Math.max(iw / iW, ih / iH), dw = iW * scale, dh = iH * scale;
    g.save(); g.beginPath(); g.rect(bPx, bPx, iw, ih); g.clip();
    g.drawImage(im, bPx + (iw - dw) * t.px / 100, bPx + (ih - dh) * t.py / 100, dw, dh); g.restore();
    return cv;
  }
  function toBlob(canvas) { return new Promise(function (ok) { var done = false, tm = setTimeout(function () { if (!done) { done = true; ok(null); } }, 20000); try { canvas.toBlob(function (b) { if (!done) { done = true; clearTimeout(tm); ok(b); } }, 'image/jpeg', 0.92); } catch (e) { clearTimeout(tm); ok(null); } }); }
  function busy(label) { st.busy = !!label; st.busyLabel = label; renderBar(); }
  function failCart(msg) { busy(null); say(msg + ' Nothing was added to your cart. Please try again.', true); }

  $('add').onclick = function () {
    var A = addState(); if (!A.ok || st.busy) return;
    var T = totals(), tiles = st.tiles.slice(), N = tiles.length, props = {}, i = 0, firstThumb = null;
    busy('Preparing tile 1 of ' + N + '…');
    function step() {
      if (i >= N) return finish();
      var t = tiles[i], n = i + 1, c = tileCm(t);
      busy('Preparing tile ' + n + ' of ' + N + '…');
      var origP = t.o && t.o.s === 'done' ? Promise.resolve(t.o.url) : (t.o && t.o.s === 'busy' ? t.o.p : (startOriginal(t), t.o.p));
      return origP.catch(function () { startOriginal(t); return t.o.p; }).then(function (origUrl) {
        var u = URL.createObjectURL(t.file);
        return loadImg(u).then(function (im) {
          var cv = printCanvas(t, im);
          if (!firstThumb) { try { var th = document.createElement('canvas'); th.width = 300; th.height = Math.round(300 * cv.height / cv.width); th.getContext('2d').drawImage(cv, 0, 0, th.width, th.height); firstThumb = th.toDataURL('image/jpeg', 0.7); } catch (e) {} }
          return toBlob(cv).then(function (blob) {
            cv.width = cv.height = 1; URL.revokeObjectURL(u); im.src = '';
            if (!blob) throw new Error('We could not prepare the print file.');
            busy('Uploading tile ' + n + ' of ' + N + '…');
            return xhrUpload(blob, function (pct) { busy('Uploading tile ' + n + ' of ' + N + '… ' + pct + '%'); });
          });
        }).then(function (printUrl) {
          props['Tile ' + n] = c.w + 'x' + c.h + ' cm · ' + (c.w === c.h ? 'square' : (c.w > c.h ? 'landscape' : 'portrait'));
          props['_Tile ' + n + ' Print Ready'] = printUrl;
          props['_Tile ' + n + ' Photo (Original)'] = origUrl;
          props['_Tile ' + n + ' Crop'] = Math.round(t.px) + '% / ' + Math.round(t.py) + '%';
          if (n === 1) props['_Preview Image'] = printUrl;
          i++; return step();
        });
      });
    }
    function finish() {
      busy('Adding to your cart…');
      var D = dims(), vid = T.vid;
      var sum = {};
      sum['Product'] = MAT[st.mat].product;
      sum['Set'] = st.count + ' tiles · ' + Math.round(D.gW) + ' × ' + Math.round(D.gH) + ' cm with ' + st.gap + ' cm gaps';
      sum['Paper'] = st.finish === 'luster' ? 'Luster (satin)' : 'Matt';
      if (st.mat === 'framed') sum['Frame Colour'] = FRAMES[st.frame].label;
      sum['Border'] = st.border ? st.border + ' cm · ' + BCOLS[st.bcol].label : 'None';
      sum['Set discount'] = T.d ? Math.round(T.d * 100) + '%' : 'None';
      sum['_Set Layout'] = D.cols + ' x ' + D.rows + ' · gap ' + st.gap + ' cm';
      sum['_Set Price Check'] = 'tiles ' + T.sub + ' - ' + Math.round(T.d * 100) + '% = ' + T.tot + ' (tile prices: ' + tiles.map(function (t) { return t.size + '=' + tilePrice(t); }).join(', ') + ')';
      sum['_Set Format'] = st.mat;
      sum['_order_page'] = window.location.pathname;
      var all = Object.assign(sum, props);
      try { if (firstThumb) sessionStorage.setItem('gap_preview_' + vid, firstThumb); } catch (e) {}
      return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: vid, quantity: 1, properties: all }] }) })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) { if (!res.ok) throw new Error((res.j && res.j.description) || 'Could not add to cart.'); busy('Added to cart'); window.location.assign('/cart'); });
    }
    step().catch(function (e) { failCart((e && e.message ? e.message : 'Something went wrong.').replace(/\.?$/, '.')); });
  };
  window.addEventListener('pageshow', function (e) { if (e.persisted && st.busy) busy(null); });

  /* ---------- view switches and full screen ---------- */
  $('vEdit').onclick = function () { st.view = 'edit'; render(); };
  $('vReal').onclick = function () { st.view = 'real'; if (st.gx == null) initPos(); render(); };
  function setFull(on) {
    st.full = on; root.classList.toggle('full', on); $('fsX').hidden = !on;
    try {
      if (on) { var el = document.documentElement; if (el.requestFullscreen) el.requestFullscreen().catch(function () {}); if (screen.orientation && screen.orientation.lock) screen.orientation.lock('landscape').catch(function () {}); }
      else { if (document.fullscreenElement && document.exitFullscreen) document.exitFullscreen().catch(function () {}); if (screen.orientation && screen.orientation.unlock) screen.orientation.unlock(); }
    } catch (_) {}
    renderWall();
  }
  $('fsBtn').onclick = function () { setFull(true); };
  $('fsX').onclick = function () { setFull(false); };
  document.addEventListener('fullscreenchange', function () { if (!document.fullscreenElement && st.full) setFull(false); });
  window.addEventListener('resize', renderWall);
  if (window.ResizeObserver) new ResizeObserver(function () { renderWall(); }).observe($('wall'));

  /* start: ?count=6&mat=dibond preselects a set (used by the links on the magnetic prints page) */
  try {
    var qs = new URLSearchParams(window.location.search), n = parseInt(qs.get('count'), 10), m = qs.get('mat');
    if (SETDISC[n]) st.count = n;
    if (m === 'dibond' || m === 'framed') { st.mat = m; mark('style'); }
  } catch (e) {}
  resetTiles(); render();
})();
